<div *ngIf="loading" class="flex justify-content-center align-items-center mt-5">
  <p-progressSpinner></p-progressSpinner>
</div>
<div *ngIf="filters.length!==0">
<div *ngFor="let filter of filters;" [ngClass]="styleClass" [id]="filter.id" class="max-saveflte-panel px-4 py-3 border-gray">
  <div class="max-savedFlte-header flex gap-2 justify-content-between align-items-center">
    <div class="flex align-items-center gap-2">
        <div *ngIf="!filter.isEditing" class="max-savedFlte-title">
          <div class="flex gap-1 align-items-center">
            <span >{{ filter.name }}</span>
            <img src="/assets/info-icon.svg" alt="info" [pTooltip]="getToolTip(filter)" tooltipPosition="right" positionStyle="fixed" tooltipEvent="hover"/>
            <img *ngIf="filter.privateFilter" src="/assets/user-icon.svg" class="w-rem h-1rem" alt="info" [pTooltip]="'This filter is Private and wont be visible to other users'" tooltipPosition="right" positionStyle="fixed" tooltipEvent="hover"/>
          </div>
        </div>
        <input *ngIf="filter.isEditing" type="text" [value]="filter.name" [(ngModel)]="filter.name" >
        <input *ngIf="!filter.isEditing" type="button" [value]="appliedFilter?.id == filter.id ? 'Applied': 'Apply'" (click)="onApplyFilter(filter)" class="max-filter-actBtn" [ngStyle]="{ 'background-color': appliedFilter?.id == filter.id ? '#003DA5' : null, color: appliedFilter?.id == filter.id ? '#fff' : null }" />
    </div>
    <div>
      <div class="flex align-items-center justify-content-between gap-2 mxn-saved-fltrEdit">
        <div class="flex align-items-center justify-content-between gap-2" *ngIf="filter.isEditable">
          <div class="privateComment-checkbox align-items-end">
            <p-radioButton
              [(ngModel)]="filter.privateFilter"
              (ngModelChange)="filter.id && !filter.isEditing && updateExistingFilterSetSharedPrivate($event, filter)"
              inputId="FilterPrivacy1"
              name="FilterPrivacy"
              [value]="true"
              class="bg-transparent border-none cursor-pointer text-xs"
            />
            <label for="FilterPrivacy1" class="ml-1"> <span class="text-xs">Private</span></label>
            <p-radioButton
              [(ngModel)]="filter.privateFilter"
              (ngModelChange)="filter.id && !filter.isEditing && updateExistingFilterSetSharedPrivate($event, filter)"
              inputId="FilterPrivacy2"
              name="FilterPrivacy"
              [value]="false"
              class="bg-transparent border-none cursor-pointer text-xs ml-2"
            />
            <label for="FilterPrivacy2" class="ml-1"> <span class="text-xs">Shared</span></label>
          </div>
          <button *ngIf="!filter.isEditing" class="bg-transparent border-none cursor-pointer" (click)="onEdit(filter)"><img src="/assets/edit-icon.svg" alt="edit"></button>
          <button *ngIf="filter.isEditing" class="bg-transparent border-none cursor-pointer" (click)="onSave(filter)"><img src="/assets/saveFltr.svg" alt="save"></button>
          <button class="bg-transparent border-none cursor-pointer" (click)="onDelete(filter)"><img src="/assets/trash.svg" alt="trash"></button>
        </div>
        <input type="button" [value]="defaultFilterId == filter.id ? 'Remove default filter' : 'Set as default filter'"
        class="max-filter-actBtn" 
        [ngClass]="{ 'bg-red-400 border-red-400 text-white defaultFilter-applied': defaultFilterId && filter.id && defaultFilterId == filter.id, 'hidden': !filter.id }"
        (click)="defaultFilterId == filter.id ? removeDefaultFilter(filter) : onApplyAndSetDefaultFilter(filter)"/>
      </div>
      </div>
  </div>
  <app-chips-list [chips]="filter.filterValues" [removable]="edit" (removedChip)="handleRemovedChip($event, filter)"></app-chips-list>
  <div *ngIf="filter.isEditable && filter.isEditing" class="flex align-items-center gap-1">
      <span class="mxn-sortby-icon">
        <img src="/assets/exclamation.svg" alt="exclamation">
      </span>
      <p class="p-0 m-0 font-italic text-sm">{{sharedPrivateFilterNotes}}</p>
  </div>
</div>
</div>
<p-dialog [modal]="true" [(visible)]="visible" styleClass="max-confirmation-dialog">
  <div class="flex gap-3 px-4">
    <div class="mxn-popup-icon">
      <div class="mxn-warning">
        <img src="assets/ph_warning-light.svg" alt="warning-light">
      </div>
    </div>
    <div class="flex-1">
      <h3 class="m-0 mb-2">Alert</h3>
      <p class="m-0">Are you sure you want to delete <strong>{{toBeDeleted?.name??''}}</strong> filter?</p>
      <p class="m-0">This action cannot be undone</p>
    </div>
  </div>
  <div class="flex justify-content-end gap-2 max-dialog-footer">
    <p-button label="Cancel" severity="secondary" (onClick)="handleCancelDelete()" class="max-dialog-cancel-btn"/>
    <p-button label="Confirm" (onClick)="visible = false" (onClick)="handleConfirmDelete()" class="max-dialog-Confirm-btn"/>
</div>
</p-dialog>
<p-dialog
  [modal]="true"
  [(visible)]="markPrivateSharedFilterModal"
  styleClass="max-confirmation-dialog"
>
  <div class="flex gap-3 px-4">
    <div class="mxn-popup-icon">
      <div class="mxn-warning">
        <img src="assets/ph_warning-light.svg" alt="warning-light" />
      </div>
    </div>
    <div class="flex-1">
      <h3 class="m-0 mb-2">Alert</h3>
      <p class="m-0">{{filterModalText}}</p>
    </div>
  </div>
  <div class="flex justify-content-end gap-2 max-dialog-footer">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="markPrivateSharedFilterModal = false"
      (onClick)="onMarkPrivateSharedFilterCancel()"
      class="max-dialog-cancel-btn"
    />
    <p-button
      label="Confirm"
      (onClick)="markPrivateSharedFilterModal = false"
      (onClick)="onMarkPrivateSharedFilterConfirm()"
      class="max-dialog-Confirm-btn"
    />
  </div>
</p-dialog>
